import React, { useState } from 'react'
import { connect } from 'react-redux'
import SquareIntegration from '../../components/Square/SquareIntegration'
import SquareImportButton from '../../components/Buttons/squareImport'
import withLayout from '../../Layouts/AdminPanel'

const SquareIntegrationPage = ({ Restaurant, Dish, Category }) => {
	const [connectionStatus, setConnectionStatus] = useState(null)

	return (
		<div className="square-integration-page">
			<div className="page-header">
				<h1>Square POS Integration</h1>
				<p>
					Connect your Square account to automatically import menu items, categories, and images from your
					Square POS system.
				</p>
			</div>

			<div className="integration-sections">
				{/* Connection Status and OAuth */}
				<section className="section">
					<SquareIntegration onStatusChange={setConnectionStatus} />
				</section>

				{/* Import Section */}
				<section className="section">
					<div className="import-section-card">
						<h3>Import Catalog</h3>
						<p>
							Import your menu items from Square. This will create dishes and categories in your Foodi
							menu based on your Square catalog.
						</p>
						<SquareImportButton
							Restaurant={Restaurant}
							Dish={Dish}
							Category={Category}
							showConnectionStatus={true}
							connectionStatus={connectionStatus}
						/>
					</div>
				</section>

				{/* Information Section */}
				{/* <section className="section info-section">
                    <h3>About Square Integration</h3>
                    <div className="info-content">
                        <h4>What gets imported?</h4>
                        <ul>
                            <li>Menu items and all their variations</li>
                            <li>Categories and their organization</li>
                            <li>Item descriptions and pricing</li>
                            <li>Images associated with items</li>
                        </ul>

                        <h4>How does it work?</h4>
                        <ol>
                            <li>Connect your Square account using the button above</li>
                            <li>Authorize Foodi to access your Square catalog</li>
                            <li>Click "Import from Square" to sync your menu</li>
                            <li>Your items will appear in the Dishes and Categories sections</li>
                        </ol>

                        <h4>Security</h4>
                        <p>
                            Your Square credentials are stored securely and encrypted. Foodi uses OAuth 2.0
                            for authentication, which means we never see your Square password. You can
                            disconnect at any time.
                        </p>
                    </div>
                </section> */}
			</div>

			<style jsx="true">{`
				.square-integration-page {
					max-width: 1000px;
					margin: 0 auto;
					padding: 20px;
				}

				.page-header {
					margin-bottom: 32px;
				}

				.page-header h1 {
					margin: 0 0 12px 0;
					font-size: 32px;
					font-weight: 600;
					color: #333;
				}

				.page-header p {
					margin: 0;
					font-size: 16px;
					color: #666;
					line-height: 1.5;
				}

				.integration-sections {
					display: flex;
					flex-direction: column;
					gap: 24px;
				}

				.section {
					background: white;
					border-radius: 8px;
					overflow: hidden;
				}

				.import-section-card {
					padding: 24px;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
				}

				.import-section-card h3 {
					margin: 0 0 12px 0;
					font-size: 20px;
					font-weight: 600;
				}

				.import-section-card > p {
					margin: 0 0 20px 0;
					color: #666;
					line-height: 1.5;
				}

				.info-section {
					padding: 24px;
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
				}

				.info-section h3 {
					margin: 0 0 20px 0;
					font-size: 20px;
					font-weight: 600;
				}

				.info-content h4 {
					margin: 20px 0 12px 0;
					font-size: 16px;
					font-weight: 600;
					color: #333;
				}

				.info-content h4:first-child {
					margin-top: 0;
				}

				.info-content ul,
				.info-content ol {
					margin: 0 0 16px 0;
					padding-left: 24px;
					color: #666;
				}

				.info-content li {
					margin: 8px 0;
					line-height: 1.5;
				}

				.info-content p {
					margin: 0 0 16px 0;
					color: #666;
					line-height: 1.5;
				}

				@media (max-width: 768px) {
					.square-integration-page {
						padding: 16px;
					}

					.page-header h1 {
						font-size: 24px;
					}

					.import-section-card,
					.info-section {
						padding: 16px;
					}
				}
			`}</style>
		</div>
	)
}

const mapStateToProps = (state) => ({
	Restaurant: state?.Restaurant,
	Dish: state?.Dish,
	Category: state?.Category,
})

export default connect(mapStateToProps)(withLayout(SquareIntegrationPage))
